import React, {useEffect} from 'react';
import {Footer} from './components/Footer';
import {useSiteSettings} from "./sanity/useSiteSettings";
import {urlFor} from "./sanity/imageUrl";

const Layout = ({ children }) => {
    const {data} = useSiteSettings();

    useEffect(() => {
        const root = document.documentElement;
        const bg = data?.backgroundImages || {};
        const setVar = (name, image) => {
            if (image) {
                root.style.setProperty(name, `url("${urlFor(image)}")`);
            } else {
                root.style.removeProperty(name);
            }
        };
        setVar('--header-bg', bg.header);
        setVar('--quote-bg', bg.quote);
        setVar('--footer-bg', bg.footer);
        setVar('--newsletter-bg', bg.newsletter);
        setVar('--contact-bg', bg.contact);
        setVar('--newsletter-pic-bg', bg.newsletterPic);
    }, [data]);

    return (
        <div className="layout">
            <div className="layout-content">
                {children}
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
